export default "__VITE_ASSET__92524f3b__"